import { AppBar, Toolbar, Container, Box, makeStyles } from "@material-ui/core"
import { graphql, Link as GatsbyLink, useStaticQuery } from "gatsby"
import React from "react"
import DropdownLink, { Link } from "./DropdownLink"
import HoverLink from "./HoverLink"
import Logo_VTH from "./VTHLogo.svg"

const useStyles = makeStyles(theme => ({
  appBar: {
    height: "80px",
  },
  toolbar: {
    height: "80px",
  },
  logo: {
    position: "absolute",
    display: "flex",
    justifyContent: "center",
    width: "100%",
    "& img": {
      cursor: "pointer",
      transition: theme.transitions.create("all", {
        easing: theme.transitions.easing.easeOut,
      }),
      zIndex: 1,
      height: "100px",
      marginTop: "8px",
      [theme.breakpoints.down("xs")]: {
        height: "70px",
        marginTop: "6px",
      },
      "&:hover": {
        transform: "scale(1.1)",
      },
    },
  },
  offset: {
    minHeight: "80px",
  },
  boxLeft: {
    display: "flex",
    flexBasis: "50%",
    marginRight: "70px",
    [theme.breakpoints.down("xs")]: {
      flexDirection: "column",
    },
  },
  boxRight: {
    display: "flex",
    flexBasis: "50%",
    justifyContent: "flex-end",
    marginLeft: "70px",
    [theme.breakpoints.down("xs")]: {
      flexDirection: "column",
      alignItems: "flex-end",
    },
  },
}))

const Header = () => {
  const classes = useStyles()
  const data = useStaticQuery(query)
  const teamLinks: Link[] = data.allSanityTeam.nodes.map(t => {
    return { name: t.name, to: "/teams/" + t.slug.current }
  })
  return (
    <>
      <AppBar position="fixed" color="primary" className={classes.appBar}>
        <GatsbyLink to="/">
          <div className={classes.logo}>
            <img src={Logo_VTH} alt="VTH Logo" />
          </div>
        </GatsbyLink>
        <Toolbar className={classes.toolbar} disableGutters>
          <Container maxWidth="md">
            <Box display="flex">
              <Box className={classes.boxLeft}>
                <HoverLink
                  name="News"
                  to="/news"
                  variant="h5"
                  style={{ marginRight: "20%" }}
                />
                <DropdownLink name="Teams" links={teamLinks} />
              </Box>
              <Box className={classes.boxRight}>
                <HoverLink name="Spielplan" to="/schedule" variant="h5" />
                <HoverLink
                  name="Kontakt"
                  to="/contact"
                  variant="h5"
                  style={{ marginLeft: "20%" }}
                />
              </Box>
            </Box>
          </Container>
        </Toolbar>
      </AppBar>
      <div className={classes.offset} />
    </>
  )
}

export default Header

const query = graphql`
  query {
    allSanityTeam {
      nodes {
        id
        name
        slug {
          current
        }
      }
    }
  }
`
